import { Paper, TableContainer } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { lessonsArray, months } from "../../utilities/const/const";
import {
  getIndividualClassAttendance,
  getLessons,
} from "../../utilities/const/functions";
import { AuthContext } from "../../utilities/context/AuthContext";
import { modules } from "../AllAttendanceReport/AllAttendanceClassTable";
import classes from "../AllAttendanceReport/AllAttendanceReport.module.css";
import IndividualAttendancePopUp from "../AllAttendanceReport/IndividualAttendancePopUp";
import InfoPopup from "../AllAttendanceReport/InfoPopup";

export default function ClassAttendanceTable({ classData, studentInfo }) {
  const [attendanceData, setAttendanceData] = useState([]);
  const [lessons, setLessons] = useState([]);
  const { setLoading } = useContext(AuthContext);
  const [add, setAdd] = useState(false);
  const [month, setMonth] = useState(months);
  const params = useParams();
  const studentId = params.id;
  //getIndividualClassAttendance
  const fetchAttendanceData = async () => {
    // console.log({ data: "fetchingAttendanceData--" + classData?.id });
    if (!classData.id) {
      return;
    }
    try {
      setLoading(true);
      const res = await getIndividualClassAttendance(
        classData.id,
        studentId,
        classData.intakeMonth,
        classData.intakeYear
      );
      const lessonRes = await getLessons(classData.id);
      // console.log({ [classData.id]: res?.data });
      setLessons(lessonRes?.data ?? []);
      if (!res.error) {
        // console.log({ [classData.id]: res?.data });
        let resData = res?.data;
        // if (!resData.length > 0) {
        //   setLoading(false);
        //   return;
        // }
        // setAttendanceData(res?.data);
        let attArr = new Array(lessonRes?.data?.length).fill(0);
        // console.log({ resData });
        resData.forEach((ele) => {
          // let d = new Date(e?.date?.seconds * 1000);
          // var date = d.getDate();
          // var day = d.getDay();
          // var weekOfMonth = Math.ceil((date - 1 - day) / 7);
          // //   console.log({ date: d.toDateString() });
          // let passedWeek = d.getMonth() * 4;
          // let position = passedWeek + weekOfMonth;
          let position = lessonRes?.data
            ?.map((e) => e.id)
            .indexOf(ele.lessonId);
          let presentStatus = ele.replacementStatus
            ? "R"
            : ele.presentStatus
            ? "P"
            : "A";
          attArr[position] = { ...ele, status: presentStatus };
        });
        setAttendanceData(attArr);
      } else {
        window.alert(res.message);
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };

  useEffect(() => {
    fetchAttendanceData();
    let modify = [...months];
    for (let index = 0; index < classData.intakeMonth; index++) {
      modify.push(modify.shift());
    }
    setMonth(modify);
  }, [add]);

  return (
    <TableContainer
      //   component={Paper}
      sx={{
        backgroundColor: "#fff",
        borderRadius: "15px",
        minHeight: "23vh",
      }}
    >
      <table style={{ marginTop: "0px" }} className={classes.tableMain}>
        <thead>
          <tr>
            {modules.map((e) => (
              <th colSpan={12} className={classes.info}>
                {e}
              </th>
            ))}
          </tr>
          <tr>
            {month.map((e) => (
              <th key={e} colSpan={4} className={classes.months}>
                {e}
              </th>
            ))}
          </tr>
          <tr>
            {lessons?.map((e) => (
              // <th key={e} className={classes.info}>
              //   {e}
              // </th>
              <InfoPopup key={e.id} e={e} />
            ))}
          </tr>
        </thead>
        <tbody>
          {/* {JSON.stringify(attendanceData)} */}
          {attendanceData.map((e, index) => {
            return (
              // <td
              //   key={index}
              //   style={{
              //     cursor: "pointer",
              //   }}
              //   className={
              //     e == 0
              //       ? classes.pending
              //       : e == "A"
              //       ? classes.absent
              //       : e == "R"
              //       ? classes.replacement
              //       : classes.present
              //   }
              // >
              //   {e == "R" ? e : ""}
              // </td>
              <IndividualAttendancePopUp
                index={index}
                classData={classData}
                key={e.id}
                data={e}
                fetchAtt={setAdd}
                studentData={studentInfo}
                lessons={lessons}
                module={null}
              />
            );
          })}
          {/* {students?.map((item, index) => (
            <StudentRow
              shift={classData.intakeMonth}
              key={index}
              module={module}
              studentId={item}
              attendanceData={attendanceInfo[item]}
            />
          ))} */}
        </tbody>
      </table>

      {/* <Box
        sx={{
          width: "600px",
          backgroundColor: "#4285F4",
          color: "#fff",
          fontWeight: 600,
          textAlign: "center",
          padding: "20px",
        }}
      >
        Module 1 - Module Name
      </Box>
      <Table>
        <TableHead>
          <TableRow
            sx={{
              width: "600px",
              display: "flex",
              alignItems: "center",
              textAlign: "center",
              backgroundColor: "#A0C2F9",
            }}
          >
            <Box
              sx={{
                width: "200px",
                borderRight: "1px outset #000",
                color: "#fff",
                fontWeight: 600,
                padding: "20px 10px",
              }}
            >
              November
            </Box>
            <Box
              sx={{
                width: "200px",
                borderRight: "1px outset #000",
                color: "#fff",
                fontWeight: 600,
                padding: "20px 10px",
              }}
            >
              December
            </Box>
            <Box
              sx={{
                width: "200px",
                color: "#fff",
                fontWeight: 600,
                padding: "20px 10px",
              }}
            >
              January
            </Box>
          </TableRow>
          <TableRow
            sx={{
              width: "600px",
              display: "flex",
              alignItems: "center",
              backgroundColor: "#D9E7FD",
              textAlign: "center",
            }}
          >
            <Box
              sx={{
                width: "50px",
                color: "#1E1E1E",
                fontWeight: 500,
                borderRight: "1px outset #000",
                py: "10px",
              }}
            >
              W1
            </Box>
            <Box
              sx={{
                width: "50px",
                color: "#1E1E1E",
                fontWeight: 500,
                borderRight: "1px outset #000",
                py: "10px",
              }}
            >
              W2
            </Box>
            <Box
              sx={{
                width: "50px",
                color: "#1E1E1E",
                fontWeight: 500,
                borderRight: "1px outset #000",
                py: "10px",
              }}
            >
              W3
            </Box>
            <Box
              sx={{
                width: "50px",
                color: "#1E1E1E",
                fontWeight: 500,
                borderRight: "1px outset #000",
                py: "10px",
              }}
            >
              W4
            </Box>
            <Box
              sx={{
                width: "50px",
                color: "#1E1E1E",
                fontWeight: 500,
                borderRight: "1px outset #000",
                py: "10px",
              }}
            >
              W5
            </Box>
            <Box
              sx={{
                width: "50px",
                color: "#1E1E1E",
                fontWeight: 500,
                borderRight: "1px outset #000",
                py: "10px",
              }}
            >
              W6
            </Box>
            <Box
              sx={{
                width: "50px",
                color: "#1E1E1E",
                fontWeight: 500,
                borderRight: "1px outset #000",
                py: "10px",
              }}
            >
              W7
            </Box>
            <Box
              sx={{
                width: "50px",
                color: "#1E1E1E",
                fontWeight: 500,
                borderRight: "1px outset #000",
                py: "10px",
              }}
            >
              W8
            </Box>
            <Box
              sx={{
                width: "50px",
                color: "#1E1E1E",
                fontWeight: 500,
                borderRight: "1px outset #000",
                py: "10px",
              }}
            >
              W9
            </Box>
            <Box
              sx={{
                width: "50px",
                color: "#1E1E1E",
                fontWeight: 500,
                borderRight: "1px outset #000",
                py: "10px",
              }}
            >
              W10
            </Box>
            <Box
              sx={{
                width: "50px",
                color: "#1E1E1E",
                fontWeight: 500,
                borderRight: "1px outset #000",
                py: "10px",
              }}
            >
              R1
            </Box>
            <Box
              sx={{
                width: "50px",
                color: "#1E1E1E",
                fontWeight: 500,
                py: "10px",
              }}
            >
              E1
            </Box>
          </TableRow>
        </TableHead>
        <TableBody>
          {[1].map((row, index) => (
            <Box
              key={index}
              sx={{
                "&:last-child td, &:last-child th": {
                  border: 0,
                },
                display: "flex",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  ...flexCenter,
                  width: "50px",
                  height: "50px",
                  color: "#fff",
                  backgroundColor: "#F7A6D2",
                  fontWeight: 500,
                  borderRight: "1px outset #000",
                }}
              ></Box>
              <Box
                sx={{
                  ...flexCenter,
                  width: "50px",
                  height: "50px",
                  color: "#fff",
                  backgroundColor: "#F7A6D2",
                  fontWeight: 500,
                  borderRight: "1px outset #000",
                }}
              ></Box>
              <Box
                sx={{
                  ...flexCenter,
                  width: "50px",
                  height: "50px",
                  color: "#fff",
                  backgroundColor: "#F7A6D2",
                  fontWeight: 500,
                  borderRight: "1px outset #000",
                }}
              ></Box>
              <Box
                sx={{
                  ...flexCenter,
                  width: "50px",
                  height: "50px",
                  color: "#fff",
                  backgroundColor: "#159640",
                  fontWeight: 500,
                  borderRight: "1px outset #000",
                }}
              >
                R
              </Box>
              <Box
                sx={{
                  ...flexCenter,
                  width: "50px",
                  height: "50px",
                  color: "#fff",
                  backgroundColor: "#F7A6D2",
                  fontWeight: 500,
                  borderRight: "1px outset #000",
                }}
              ></Box>
              <Box
                sx={{
                  ...flexCenter,
                  width: "50px",
                  height: "50px",
                  color: "#fff",
                  backgroundColor: "#F7A6D2",
                  fontWeight: 500,
                  borderRight: "1px outset #000",
                }}
              ></Box>
              <Box
                sx={{
                  ...flexCenter,
                  width: "50px",
                  height: "50px",
                  color: "#fff",
                  backgroundColor: "#F7A6D2",
                  fontWeight: 500,
                  borderRight: "1px outset #000",
                }}
              ></Box>
              <Box
                sx={{
                  ...flexCenter,
                  width: "50px",
                  height: "50px",
                  color: "#fff",
                  backgroundColor: "#F7A6D2",
                  fontWeight: 500,
                  borderRight: "1px outset #000",
                }}
              ></Box>
              <Box
                sx={{
                  ...flexCenter,
                  width: "50px",
                  height: "50px",
                  color: "#fff",
                  backgroundColor: "#F7A6D2",
                  fontWeight: 500,
                  borderRight: "1px outset #000",
                }}
              ></Box>
              <Box
                sx={{
                  ...flexCenter,
                  width: "50px",
                  height: "50px",
                  color: "#fff",
                  backgroundColor: "#F7A6D2",
                  fontWeight: 500,
                  borderRight: "1px outset #000",
                }}
              ></Box>
              <Box
                sx={{
                  ...flexCenter,
                  width: "50px",
                  height: "50px",
                  color: "#fff",
                  backgroundColor: "#F7A6D2",
                  fontWeight: 500,
                  borderRight: "1px outset #000",
                }}
              ></Box>
              <Box
                sx={{
                  ...flexCenter,
                  width: "50px",
                  height: "50px",
                  color: "#fff",
                  backgroundColor: "#F7A6D2",
                  fontWeight: 500,
                }}
              ></Box>
            </Box>
          ))}
        </TableBody>
      </Table> */}
    </TableContainer>
  );
}
